import React from 'react';
import {Box, Button, Container, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Link} from 'react-router-dom';
import {H5, P} from 'components/TypographyShortcuts';
import useBrowserTitle from 'hooks/useBrowserTitle';

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: '4rem',
    },
}));

const WelcomeOnboardingMessage = () => {
    useBrowserTitle(`| Onboard`);
    const classes = useStyles();

    return (
        <Container maxWidth='xs'>
            <Grid
                container
                direction='column'
                justifyContent='center'
                className={classes.root}
                spacing={3}
            >
                <Grid item>
                    <Box textAlign='center'>
                        <H5>
                            <b>Congratulations!</b>
                        </H5>
                    </Box>
                </Grid>
                <Grid item>
                    <Box textAlign='center'>
                        <H5>
                            <b>Welcome to MM-SEAS!</b>
                        </H5>
                    </Box>
                </Grid>
                <Grid item>
                    <Box textAlign='center'>
                        <P>
                            To get started you will need your maritime documents
                            including Sea Service and Training Certificates to
                            enter them into the software.
                        </P>
                    </Box>
                </Grid>
                <Grid item>
                    <Box padding='1rem' textAlign='center'>
                        <Button
                            component={Link}
                            to='/forms/onboard'
                            variant='contained'
                            color='primary'
                        >
                            Proceed into MM-SEAS and create your account
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default WelcomeOnboardingMessage;
